import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { QuoteVersions } from '../../../quote/alpaca/model/quote/quote_versions.model';
import { formatDate } from '@angular/common';
import { NgForm } from '@angular/forms';
import { AlQuoteService } from '../../../quote/alpaca/al-quote/al-quote.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-al-policy-financials',
  templateUrl: './financials.component.html',
  styles: [
  ]
})
export class AlPolicyFinancialsComponent implements OnInit {
  @Input() quoteData: QuoteVersions;
  quote;

  constructor(private quoteService: AlQuoteService, private _snackBar: MatSnackBar) { }

  ngOnChanges(changes: SimpleChanges) {
    this.quote = this.quoteData;
  }

  ngOnInit(): void {

  }

}